// extracted by mini-css-extract-plugin
export default {"container":"ProfileQrButton_container__C39Yt","title":"ProfileQrButton_title__YUF1O","message":"ProfileQrButton_message__1GYQf","switch":"ProfileQrButton_switch__QyKKO"};